import { getIntegrationDisplayName, type IntegrationServiceId } from '../../../../common/integrations'
import React, { type FC, useCallback, useState } from 'react'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'
import { IntegrationConnection } from '../../../Integration/Connectors/IntegrationConnection'
import { Button } from '../../../../components/Button/Button'

interface SecondaryEmptyStateIntegrationButtonsProps {
  integrationIds: IntegrationServiceId[]
  postConnectRedirectPath?: string | ((serviceId: IntegrationServiceId) => string)
  onIntegrationSelect?: (serviceId: IntegrationServiceId) => void
}

export const OnboardingBannerIntegrationButtons: FC<SecondaryEmptyStateIntegrationButtonsProps> = ({
  integrationIds,
  postConnectRedirectPath,
  onIntegrationSelect,
}) => {
  const [activeConnectId, setActiveConnectId] = useState<IntegrationServiceId | null>(null)

  const handleSelect = useCallback(
    (serviceId: IntegrationServiceId) => {
      onIntegrationSelect?.(serviceId)
      setActiveConnectId(serviceId)
    },
    [onIntegrationSelect],
  )

  const resolvePostConnectPath = useCallback(
    (serviceId: IntegrationServiceId): string | undefined =>
      typeof postConnectRedirectPath === 'function' ? postConnectRedirectPath(serviceId) : postConnectRedirectPath,
    [postConnectRedirectPath],
  )

  return (
    <div className={'d-flex flex-row gap-3'}>
      {integrationIds.map((serviceId) => (
        <React.Fragment key={serviceId}>
          <Button
            variant={'grayButton'}
            className={'d-inline-flex gap-2 rounded-3'}
            aria-label={`Connect ${getIntegrationDisplayName(serviceId)}`}
            onClick={() => handleSelect(serviceId)}
          >
            <IntegrationIcon serviceId={serviceId} width={20} height={20} />
            <span className={'fw-semibold small text-truncate mw-100'}>Connect {getIntegrationDisplayName(serviceId)}</span>
          </Button>
          <IntegrationConnection
            serviceId={serviceId}
            startConnect={activeConnectId === serviceId}
            onConnected={() => setActiveConnectId(null)}
            postConnectRedirectPath={resolvePostConnectPath(serviceId)}
          />
        </React.Fragment>
      ))}
    </div>
  )
}
